module.exports = __webpack_public_path__ + "fonts/Inter-400-latin49.8e433c0.woff2";